import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { ShieldAlert, ArrowLeft } from 'lucide-react';

const ALIAS_MAP = {
  procurement: ['procurement', 'operations', 'buy', 'po'],
  operations: ['operations', 'procurement', 'buy', 'po'],
  inventory: ['inventory', 'stock'],
  finance: ['finance', 'gl', 'accounts', 'pay'],
  budget: ['budget', 'plan'],
  grc: ['grc', 'govern', 'compliance'],
  vendor_portal: ['vendor_portal', 'vendor'],
  client_portal: ['client_portal', 'client'],
  help_support: ['help_support', 'help', 'tickets', 'support'],
  pos: ['pos', 'store'],
  multi_currency: ['multi_currency', 'fx', 'currencies'],
  analytics_ai: ['analytics_ai', 'analytics', 'dashboard', 'ai']
};

export default function ModuleGuard({ module, children, fallback = null }) {
  const { isModuleEnabled, isSuperAdmin, roleScope } = useAuth();

  if (!module) return children;

  if (isSuperAdmin) return children;

  if (isModuleEnabled(module)) {
    return children;
  }

  if (fallback) {
    return fallback;
  }

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center p-6 text-center">
      <div className="w-16 h-16 bg-amber-100 dark:bg-amber-950/40 rounded-full flex items-center justify-center text-amber-600 dark:text-amber-400 mb-4 shadow-inner">
        <ShieldAlert className="w-8 h-8" />
      </div>
      <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100 mb-2">
        Module Disabled
      </h2>
      <p className="text-slate-600 dark:text-slate-400 max-w-md mb-6 text-sm">
        The module <span className="font-semibold text-slate-800 dark:text-slate-200">"{module}"</span> is disabled or not included in your tenant's subscription plan.
      </p>
      <div className="flex gap-3">
        <a
          href="/dashboard"
          className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Dashboard
        </a>
      </div>
    </div>
  );
}
